import React from 'react';

export const Footer = () => {
  return (
    <footer className="py-12 pb-24 md:pb-12 bg-[#fcf6f1] mt-auto border-t border-[#e8ddd4]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
        <p className="font-display text-2xl mb-2 text-[#8d5f3f]">Gelly & Christopher</p>
        <p className="text-[#8d5f3f]/60 text-sm tracking-widest uppercase">
          18 Octobre 2026 • Séville, Espagne
        </p>
        <div className="mt-8 flex justify-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/ok3lmo58_Orange%203.png"
            alt="Orange decoration"
            className="h-16 w-auto opacity-60"
          />
        </div>
      </div>
    </footer>
  );
};
